var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMproLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 27,
    viewBox: "0 0 77 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 2.23858 2.23858 0 5 0H25C27.7614 0 30 2.23858 30 5V22C30 24.7614 27.7614 27 25 27H5C2.23858 27 0 24.7614 0 22V5ZM12.7711 17.0926C13.0386 17.4391 13.4283 17.6694 13.8596 17.7372C14.0256 17.7651 14.1963 17.7687 14.3663 17.7463C14.816 17.6873 15.2238 17.4522 15.5002 17.0926L21.8503 8.81663C22.1261 8.45652 22.2477 8.00164 22.1883 7.55196C22.1288 7.10227 21.8933 6.69458 21.5334 6.41847C21.1733 6.14266 20.7184 6.02112 20.2688 6.08054C19.8191 6.13996 19.4114 6.37549 19.1353 6.73536L14.4396 12.8556L14.4371 12.8525L14.1293 13.2539L9.13631 6.73567C9.06056 6.63671 8.9742 6.54628 8.8793 6.46642C8.80311 6.40231 8.72128 6.34482 8.63468 6.29472C8.4402 6.18221 8.22545 6.10915 8.00271 6.07972C7.77997 6.05029 7.55362 6.06506 7.33659 6.12319C7.11957 6.18132 6.91614 6.28167 6.73793 6.41849L6.7285 6.4258C6.37332 6.70118 6.14059 7.10537 6.08093 7.55114C6.07853 7.56907 6.07642 7.58701 6.07459 7.60496C6.06828 7.66471 6.06505 7.72538 6.06505 7.7868V18.7697C6.06505 19.7147 6.83073 20.4809 7.77524 20.4809C8.71976 20.4809 9.48544 19.7147 9.48544 18.7697V12.8157L9.97638 13.4556V13.4491L12.7711 17.0926ZM18.3359 18.5341C18.1575 18.3975 18.0078 18.2271 17.8953 18.0326C17.7828 17.8382 17.7097 17.6234 17.6803 17.4007C17.6508 17.1779 17.6656 16.9516 17.7237 16.7346C17.7819 16.5175 17.8822 16.3141 18.0191 16.1359L22.9973 9.64881C23.2734 9.28894 23.6811 9.05341 24.1308 8.99399C24.5805 8.93456 25.0354 9.05611 25.3955 9.33192C25.7554 9.60803 25.9909 10.0157 26.0503 10.4654C26.1097 10.9151 25.9882 11.37 25.7124 11.7301L20.7341 18.2192C20.4577 18.5788 20.0499 18.8139 19.6002 18.8729C19.1505 18.932 18.6958 18.8101 18.3359 18.5341Z",
    fill: "url(#paint0_linear_12561_22963)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.162 21V4.89999H44.786C46.212 4.89999 47.431 5.12999 48.443 5.58999C49.4703 6.04999 50.26 6.70933 50.812 7.56799C51.364 8.42666 51.64 9.44633 51.64 10.627C51.64 11.8077 51.364 12.8273 50.812 13.686C50.26 14.5447 49.4703 15.204 48.443 15.664C47.431 16.124 46.212 16.354 44.786 16.354H39.818L41.152 14.951V21H38.162ZM41.152 15.273L39.818 13.824H44.648C45.9667 13.824 46.9557 13.548 47.615 12.996C48.2897 12.4287 48.627 11.639 48.627 10.627C48.627 9.59966 48.2897 8.80999 47.615 8.25799C46.9557 7.70599 45.9667 7.42999 44.648 7.42999H39.818L41.152 5.95799V15.273Z",
    fill: "url(#paint1_linear_12561_22963)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2375 21V8.71799H56.9745V12.099L56.6525 11.11C57.0205 10.282 57.5956 9.65333 58.3776 9.22399C59.1749 8.79466 60.1639 8.58 61.3445 8.58V11.317C61.2219 11.2863 61.1069 11.271 60.9995 11.271C60.8922 11.2557 60.7849 11.248 60.6775 11.248C59.5889 11.248 58.7225 11.57 58.0786 12.214C57.4346 12.8427 57.1125 13.7857 57.1125 15.043V21H54.2375Z",
    fill: "url(#paint2_linear_12561_22963)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1911 21.161C67.9338 21.161 66.8145 20.8927 65.8331 20.356C64.8518 19.804 64.0775 19.0527 63.5101 18.102C62.9428 17.1513 62.6591 16.0703 62.6591 14.859C62.6591 13.6323 62.9428 12.5513 63.5101 11.616C64.0775 10.6653 64.8518 9.92166 65.8331 9.385C66.8145 8.84833 67.9338 8.58 69.1911 8.58C70.4638 8.58 71.5908 8.84833 72.5721 9.385C73.5688 9.92166 74.3431 10.6577 74.8951 11.593C75.4625 12.5283 75.7461 13.617 75.7461 14.859C75.7461 16.0703 75.4625 17.1513 74.8951 18.102C74.3431 19.0527 73.5688 19.804 72.5721 20.356C71.5908 20.8927 70.4638 21.161 69.1911 21.161ZM69.1911 18.7C69.8965 18.7 70.5251 18.5467 71.0771 18.24C71.6291 17.9333 72.0585 17.4887 72.3651 16.906C72.6871 16.3233 72.8481 15.641 72.8481 14.859C72.8481 14.0617 72.6871 13.3793 72.3651 12.812C72.0585 12.2293 71.6291 11.7847 71.0771 11.478C70.5251 11.1713 69.9041 11.018 69.2141 11.018C68.5088 11.018 67.8801 11.1713 67.3281 11.478C66.7915 11.7847 66.3621 12.2293 66.0401 12.812C65.7181 13.3793 65.5571 14.0617 65.5571 14.859C65.5571 15.641 65.7181 16.3233 66.0401 16.906C66.3621 17.4887 66.7915 17.9333 67.3281 18.24C67.8801 18.5467 68.5011 18.7 69.1911 18.7Z",
    fill: "url(#paint3_linear_12561_22963)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12561_22963",
    x1: -0.534548,
    y1: 33.612,
    x2: 17.2467,
    y2: -4.07323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442479,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_12561_22963",
    x1: 30.9828,
    y1: 30.7331,
    x2: 36.9111,
    y2: -1.29006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186004,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_12561_22963",
    x1: 30.9828,
    y1: 30.7331,
    x2: 36.9111,
    y2: -1.29006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186004,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_12561_22963",
    x1: 30.9828,
    y1: 30.7331,
    x2: 36.9111,
    y2: -1.29006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4645ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186004,
    stopColor: "#4C5FEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72FFFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMproLogo);
export default __webpack_public_path__ + "static/media/mpro-logo.4b3349307b5636ba1f0bcc05bd332e06.svg";
export { ForwardRef as ReactComponent };